<template>
  <v-card-text class="flex flex-grow-1 px-2 py-1">
    <div v-if="presentation.is_internal_use_only"
         class="font-size-12 font-italic">
      FOR INTERNAL USE ONLY
    </div>
  </v-card-text>
</template>
<script>
export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    }
  }
}
</script>
